import { render, staticRenderFns } from "./member-upload-cert-dialog.vue?vue&type=template&id=f5bfffac&"
import script from "./member-upload-cert-dialog.vue?vue&type=script&lang=js&"
export * from "./member-upload-cert-dialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports